import { PaginatedAPIResponse } from "../models/NetworkResponse";
import { GetStockParams } from "../models/Stock/GetStockParams";
import {
  Product,
  Stock,
  StockCheckSuggestedProducts,
} from "../models/Stock/Stock";
import { getAPI, postAPI, putAPI } from "./Networking";

export default class StockAPI {
  getStockList = async (
    params: GetStockParams,
  ): Promise<PaginatedAPIResponse<Stock>> => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page_no)
        queryParams.append("page_no", params.page_no.toString());
      if (params.limit) queryParams.append("limit", params.limit.toString());
      if (params.sortBy) queryParams.append("sort_by", params.sortBy);
      if (params.sortType)
        queryParams.append("sort_type", params.sortType.toString());
      // if (params.name) queryParams.append("name", params.name);
      // if (params.category_id && params.category_id.length !== 0)
      //   queryParams.append("category_id", params.category_id.join(","));
      // queryParams.append("active", params.active === false ? "0" : "1");
      // if (params.active)
      //
      // else queryParams.append("active", "true");
      const response = await getAPI(
        `/v5/stock-check-requests?${queryParams.toString()}`,
      );
      return response.result as PaginatedAPIResponse<Stock>;
    } catch (error) {
      throw error;
    }
  };

  //   getProducts = async (
  //     params: GetProductsParams
  //   ): Promise<PaginatedAPIResponse<Product>> => {
  //     try {
  //       const queryParams = new URLSearchParams();
  //       if (params.page_no)
  //         queryParams.append("page_no", params.page_no.toString());
  //       if (params.limit) queryParams.append("limit", params.limit.toString());
  //       if (params.sortBy) queryParams.append("sort_by", params.sortBy);
  //       if (params.sortType)
  //         queryParams.append("sort_type", params.sortType.toString());
  //       if (params.name) queryParams.append("name", params.name);
  //       if (params.category_id && params.category_id.length !== 0)
  //         queryParams.append("category_id", params.category_id.join(","));
  //       queryParams.append("active", params.active === false ? "0" : "1");
  //       // if (params.active)
  //       //
  //       // else queryParams.append("active", "true");
  //       const response = await getAPI(`/v5/products?${queryParams.toString()}`);
  //       return response.result as PaginatedAPIResponse<Product>;
  //     } catch (error) {
  //       throw error;
  //     }
  //   };

  getStockListByOrderId = async (orderId: number) => {
    try {
      const response = await getAPI(
        `/v5/stock-check-requests/order-id/${orderId}`,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  getEligibleProductsByOrderId = async (orderId: number) => {
    try {
      const response = await getAPI(
        `/v5/stock-check-requests/order-id/${orderId}/eligible-products`,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  raiseStockCheckRequest = async (orderId: number, products: Product[]) => {
    try {
      const prod = {
        products,
      };
      const response = await postAPI(
        `/v5/stock-check-requests/order-id/${orderId}`,
        prod,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  updateStockCheckRequest = async (
    orderId: number,
    requestId: number,
    options: {
      status?: number;
      products?: Product[];
      suggestedProducts?: StockCheckSuggestedProducts[];
    },
  ) => {
    try {
      const body: any = {};
      if (options.status !== undefined) {
        body.status = options.status;
        const response = await putAPI(
          `/v5/stock-check-requests/order-id/${orderId}/request-id/${requestId}`,
          body,
        );
        return response;
      }

      if (options.products || options.suggestedProducts) {
        if (options.products) {
          body.products = options.products;
        }

        if (options.suggestedProducts) {
          body.suggested_products = options.suggestedProducts;
        }

        const response = await putAPI(
          `/v5/stock-check-requests/order-id/${orderId}/request-id/${requestId}`,
          body,
        );
        return response;
      }
    } catch (error) {
      throw error;
    }
  };
}
